<template>
  <FormItem prop="value" :rules="rules" style="display: flex; flex-direction: column;">
    <input class="input-answer" v-model="config.value" type="number">
    <div style="display: flex; margin-top: 12px;">
      <input class="input-answer code" v-model="config.otherAnswer">
      <span class="btn" :class="{ disabled: disableCodeBtn }" @click="getCode">{{codeText}}</span>
    </div>
  </FormItem>
</template>

<script>
import { sendPhoneCode } from '@/service/question'
export default {
  name: 'Shouji',
  props: ['rules', 'config'],
  data () {
    return {
      codeText: '获取验证码',
      disableCodeBtn: false
    }
  },
  computed: {},
  methods: {
    getCode () {
      if (this.disableCodeBtn) {
        return
      }
      const phone = this.config.value
      if (!phone || !/^((1[0-9]{2})+\d{8})$/.test(phone)) {
        this.$ipsosMessage({
          message: '请输入正确的手机号'
        })
        return
      }
      const param = {
        phone,
        type: '6'
      }
      sendPhoneCode(param).then(_ => {
        this.countDown()
      }).catch(_ => {
        this.countDown(0)
      })
    },
    countDown (time = 60) {
      if (time === 0) {
        this.disableCodeBtn = false
        this.codeText = '获取验证码'
        return
      } else {
        this.disableCodeBtn = true
        this.codeText = '重新发送(' + time + ')'
        time--
      }
      setTimeout(() => {
        this.countDown(time)
      }, 1000)
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
  .input-answer {
    height: 79px;
    width: 380px;
    background: #eef9ff;
    border: 1px solid #60a8f5;
    outline: none;
    padding: 20px 19px;

    color: #2672ff;
    font-size: 28px;
    font-family: PingFang-SC-Medium;
    font-weight: 500;
    &.code {
      width: 230px;
    }
  }

  .btn {
    margin-left: 8px;
    height: 79px;
    width: 140px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background: #38ADAB;
    color: #fff;
    &.disabled {
      background: #E0E0E0;
      color: #000;
    }
  }

  .idcard-answer {
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/TitleBox/components/Shouji.vue